<div class="container py-4">
  <!-- Summary Card -->
  <div class="card mb-4 border-0 shadow-sm">
    <div class="card-body">
      <div class="row g-4">
        <!-- Deuda Fees -->
        <div class="col-12 col-md-4">
          <div class="p-3 rounded-3 bg-light">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <h6 class="text-muted mb-0">Deuda Fees</h6>
              <i class="fas fa-exclamation-circle text-warning"></i>
            </div>
            <h4 class="mb-0">{{ deudaFees | currency:'USD':'symbol':'1.2-2' }}</h4>
          </div>
        </div>
        <!-- Deuda Créditos -->
        <div class="col-12 col-md-4">
          <div class="p-3 rounded-3 bg-light">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <h6 class="text-muted mb-0">Deuda Créditos</h6>
              <i class="fas fa-credit-card text-primary"></i>
            </div>
            <h4 class="mb-0">{{ deudaCreditos | currency:'USD':'symbol':'1.2-2' }}</h4>
          </div>
        </div>
        <!-- Deuda Total -->
        <div class="col-12 col-md-4">
          <div class="p-3 rounded-3 bg-primary bg-opacity-10">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <h6 class="text-primary mb-0">Deuda Total</h6>
              <i class="fas fa-chart-line text-primary"></i>
            </div>
            <h4 class="mb-0 text-primary">{{ deudaTotal | currency:'USD':'symbol':'1.2-2' }}</h4>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Payments Section -->
  <div class="card mb-4">
    <div class="card-header d-flex justify-content-between align-items-center">
      <h5 class="mb-0">
        <i class="fas fa-money-bill-wave me-2"></i>
        Pagos con saldo a favor
      </h5>
      <div class="text-end">
        <small class="text-muted">Total a favor:</small>
        <h6 class="mb-0">{{ montoTotalAFavor | currency:'USD':'symbol':'1.2-2' }}</h6>
      </div>
    </div>
    <div class="card-body">
      <!-- Empty State for Payments -->
      <div *ngIf="!payments?.length" class="text-center py-4">
        <i class="fas fa-receipt fa-3x text-muted mb-3"></i>
        <h6 class="text-muted">No hay pagos registrados</h6>
        <p class="text-muted small">Los pagos aparecerán aquí cuando sean registrados</p>
      </div>

      <!-- Payments List -->
      <div class="list-group" *ngIf="payments?.length">
        <div *ngFor="let payment of payments" class="list-group-item list-group-item-action">
          <div class="d-flex w-100 justify-content-between align-items-center">
            <div>
              <div class="small text-muted">
                <div>Fecha de Pago: {{ payment['Fecha de realizacion del pago'] }}</div>
                <div class="text-primary small cursor-pointer mt-1" (click)="openBottom(paymentcontainer, { person_code: queryParams?.code, code_payment: payment['Codigo de pago'] })">
                  {{ payment['Codigo de pago'] }}
                </div>
              </div>
            </div>
            <div class="text-end">
              <div class="mb-1">
                <small class="text-muted">Monto a favor:</small>
                <h6 class="mb-0">{{ payment['Monto a favor'] | currency:'USD':'symbol':'1.2-2' }}</h6>
              </div>
              <button class="btn btn-success btn-sm mt-2"
                      (click)="openDistributionPreview(payment['posible_distribucion'], payment)"
                      [disabled]="!payment['posible_distribucion']?.length || isProcessingPayment"
                      [attr.data-payment-id]="payment['Codigo de pago']">
                <i class="fas" [ngClass]="isProcessingPayment ? 'fa-spinner fa-spin' : 'fa-money-bill-wave'"></i>
                {{isProcessingPayment ? 'Procesando...' : 'Aplicar Pago'}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Fees Section -->
  <div class="card">
    <div class="card-header d-flex justify-content-between align-items-center">
      <h5 class="mb-0">
        <i class="fas fa-exclamation-circle me-2"></i>
        Penalidades y Créditos
      </h5>
    </div>
    <div class="card-body">
      <div class="row">
        <!-- Penalidades Section -->
        <div class="col-12 col-md-6 mb-4 mb-md-0">
          <h6 class="mb-3">
            <i class="fas fa-exclamation-circle me-2"></i>
            Penalidades
          </h6>
          <!-- Filter Select -->
          <div class="mb-3">
            <select 
              class="form-select" 
              [(ngModel)]="selectedFeeFilter"
              (change)="onFeeFilterChange($event)">
              <option *ngFor="let option of filterOptions" [value]="option.value">
                {{option.label}}
              </option>
            </select>
          </div>
          <!-- Empty State for Fees -->
          <div *ngIf="!filteredFees?.length" class="text-center py-4">
            <i class="fas fa-check-circle fa-3x text-muted mb-3"></i>
            <h6 class="text-muted">No hay penalidades registradas</h6>
            <p class="text-muted small">Las penalidades aparecerán aquí cuando sean generadas</p>
          </div>

          <!-- Fees List -->
          <div class="list-group" *ngIf="filteredFees?.length">
            <div *ngFor="let fee of filteredFees" 
                 class="list-group-item list-group-item-action">
              <div class="d-flex w-100 justify-content-between align-items-center">
                <div>
                  <h6 class="mb-1">{{ fee['Nombre'] }}</h6>
                  <small class="text-muted">Crédito: {{ fee['Credito'] }}</small>
                  <br>
                  <small class="text-muted">Cuota #{{ fee['Numero de Cuota'] }}</small>
                  <br>
                  <small class="text-muted">Vencimiento: {{ fee['Fecha de vencimiento Cuota'] }}</small>
                </div>
                <div class="text-end">
                  <div class="mb-2">
                    <span class="badge" [ngClass]="{
                      'bg-success': fee._visualStatus === 'complete' || fee._visualStatus === 'awaiting-close',
                      'bg-warning': fee._visualStatus === 'pending'
                    }">
                      <ng-container [ngSwitch]="fee._visualStatus">
                        <ng-container *ngSwitchCase="'complete'">Pago Completado</ng-container>
                        <ng-container *ngSwitchCase="'awaiting-close'">Completo · Esperando cierre</ng-container>
                        <ng-container *ngSwitchCase="'pending'">Pago Pendiente</ng-container>
                        <ng-container *ngSwitchDefault>{{ fee['Status'] }}</ng-container>
                      </ng-container>
                    </span>
                  </div>
                  <div class="mb-2">
                    <small class="text-muted d-block">Deuda Fee:</small>
                    <h6 class="mb-1">{{ fee['Deuda Fee'] | currency:'USD':'symbol':'1.2-2' }}</h6>
                  </div>
                  <div class="mb-2">
                    <small class="text-muted d-block">Deuda Cuota:</small>
                    <h6 class="mb-1">{{ fee['Deuda de cuota'] | currency:'USD':'symbol':'1.2-2' }}</h6>
                  </div>
                  <div class="mt-2">
                    <button 
                            class="btn btn-outline-danger btn-sm"
                            (click)="confirmExoneration(fee)"
                            [attr.data-fee-id]="fee._id">
                      <i class="fas fa-ban me-1"></i>
                      Exonerar
                    </button>
                  </div>
                </div>
              </div>

              <!-- Banner explicativo: pago completo esperando cierre de cuota -->
              <div *ngIf="fee._visualStatus === 'awaiting-close'"
                   class="alert alert-success py-1 px-2 small mt-2 mb-0 d-flex align-items-center">
                <i class="fas fa-check-circle me-2"></i>
                Pago completo. Se marcará como Completado al cerrar la cuota.
              </div>
            </div>
          </div>
        </div>

        <!-- Créditos Section -->
        <div class="col-12 col-md-6">
          <h6 class="mb-3">
            <i class="fas fa-credit-card me-2"></i>
            Créditos
          </h6>
          <!-- Empty State for Pending Installments -->
          <div *ngIf="!pendingInstallments?.length" class="text-center py-4">
            <i class="fas fa-check-circle fa-3x text-muted mb-3"></i>
            <h6 class="text-muted">No hay créditos pendientes</h6>
            <p class="text-muted small">Los créditos aparecerán aquí cuando sean registrados</p>
          </div>

          <!-- Pending Installments List -->
          <div class="list-group" *ngIf="pendingInstallments?.length">
            <div *ngFor="let installment of pendingInstallments" 
                 class="list-group-item list-group-item-action">
              <div class="d-flex w-100 justify-content-between align-items-center">
                <div>
                  <h6 class="mb-1">Crédito #{{ installment.numero_credito }}</h6>
                  <small class="text-muted">Cuota #{{ installment.numero_cuota }}</small>
                </div>
                <div class="text-end">
                  <div class="mb-2">
                    <span class="badge" [ngClass]="{
                      'bg-success': installment.dueBalance === 0,
                      'bg-warning': installment.dueBalance > 0
                    }">
                      {{ installment.dueBalance === 0 ? 'Completado' : 'Pendiente' }}
                    </span>
                  </div>
                  <div class="mb-2">
                    <small class="text-muted d-block">Saldo pendiente:</small>
                    <h6 class="mb-1">{{ installment.dueBalance | currency:'USD':'symbol':'1.2-2' }}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Template -->
<ng-template #paymentcontainer let-offcanvas>
  <div class="offcanvas-header">
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-10 offset-md-1">
          <div class="row">
            <div class="col-10">
              <div class="text-capitalize h5 text-secondary mt-2">
                Detalle de Pago
              </div>
            </div>
            <div class="col-2 text-end pt-2">
              <button type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="offcanvas-body">
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-10 offset-md-1">
          <div class="text-start">
            <app-person-payments 
              [code_person]="params_payment['person_code']" 
              [code_payment]="params_payment['code_payment']" 
              (resetStatus)="response($event)">
            </app-person-payments>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- Modal de Previsualización de Distribución -->
<ng-template #distributionPreviewModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">
      <i class="fas fa-chart-pie me-2"></i>Previsualización de Distribución
    </h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <!-- Sección de Fees -->
    <div class="distribution-section" *ngIf="previewDistribution?.fees?.length > 0">
      <h6 class="section-title">
        <i class="fas fa-file-invoice me-2"></i>Fees
      </h6>
      <div class="timeline-container">
        <div class="timeline-item" *ngFor="let fee of previewDistribution?.fees">
          <div class="timeline-marker" [class.completed]="fee.completado"></div>
          <div class="timeline-content">
            <div class="row">
              <div class="col-8">
                <div class="timeline-header">
                  <span class="identifier">Fee #{{fee._id}}</span>
                </div>
              </div>
              <div class="col-4 text-end">
                <div class="timeline-amount">{{fee.monto_aplicable | currency:'USD':'': '1.2-2'}} USD</div>
                <div class="timeline-status">
                  <span class="badge" [ngClass]="fee.completado ? 'bg-success' : 'bg-warning'">
                    <i class="fas" [ngClass]="fee.completado ? 'fa-check' : 'fa-clock'"></i>
                    {{fee.completado ? 'Completará' : 'No completará'}}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Sección de Cuotas -->
    <div class="distribution-section mt-4" *ngIf="previewDistribution?.installments?.length > 0">
      <h6 class="section-title">
        <i class="fas fa-file-invoice-dollar me-2"></i>Cuotas
      </h6>
      <div class="timeline-container">
        <div class="timeline-item" *ngFor="let installment of previewDistribution?.installments">
          <div class="timeline-marker" [class.completed]="installment.completado"></div>
          <div class="timeline-content">
            <div class="row">
              <div class="col-8">
                <div class="timeline-header">
                  <span class="identifier">Crédito #{{installment.numero_credito}}</span>
                </div>
                <div class="timeline-concept">
                  <span class="text-muted">Cuota:</span> {{installment.numero_cuota}}
                </div>
              </div>
              <div class="col-4 text-end">
                <div class="timeline-amount">{{installment.monto_aplicable | currency:'USD':'': '1.2-2'}} USD</div>
                <div class="timeline-status">
                  <span class="badge" [ngClass]="installment.completado ? 'bg-success' : 'bg-warning'">
                    <i class="fas" [ngClass]="installment.completado ? 'fa-check' : 'fa-clock'"></i>
                    {{installment.completado ? 'Completará' : 'No completará'}}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Resumen de Distribución -->
    <div class="distribution-summary mt-4 p-3 bg-light rounded">
      <div class="row">
        <div class="col-6">
          <div class="summary-label">Total a distribuir:</div>
          <div class="summary-value">{{getTotalDistribution() | currency:'USD':'': '1.2-2'}} USD</div>
        </div>
        <div class="col-6 text-end">
          <div class="summary-label">Items a aplicar:</div>
          <div class="summary-value">{{previewDistribution?.fees?.length + previewDistribution?.installments?.length || 0}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()" [disabled]="isProcessingPayment">
      <i class="fas fa-times me-2"></i>Cancelar
    </button>
    <button type="button" class="btn btn-primary" (click)="confirmDistribution()" [disabled]="isProcessingPayment">
      <i class="fas" [ngClass]="isProcessingPayment ? 'fa-spinner fa-spin' : 'fa-check'"></i>
      {{isProcessingPayment ? 'Procesando...' : 'Confirmar Distribución'}}
    </button>
  </div>
</ng-template>

<style>
.distribution-summary {
  border: 1px solid #e9ecef;
}

.summary-label {
  color: #6c757d;
  font-size: 0.9rem;
  margin-bottom: 0.25rem;
}

.summary-value {
  font-weight: 600;
  color: #212529;
  font-size: 1.1rem;
}

.timeline-marker.completed {
  background: #198754;
}

.modal-header {
  border-bottom: 2px solid #e9ecef;
  padding: 1rem 1.5rem;
}

.modal-body {
  padding: 1.5rem;
}

.modal-footer {
  border-top: 2px solid #e9ecef;
  padding: 1rem 1.5rem;
}

.section-title {
  color: #495057;
  font-weight: 600;
  margin-bottom: 1.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #e9ecef;
}

.timeline-container {
  position: relative;
  padding-left: 2rem;
}

.timeline-container::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 2px;
  background: #e9ecef;
}

.timeline-item {
  position: relative;
  padding-bottom: 1.5rem;
}

.timeline-marker {
  position: absolute;
  left: -2.5rem;
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  background: #0d6efd;
  border: 2px solid #fff;
  box-shadow: 0 0 0 2px #e9ecef;
}

.timeline-content {
  background: #f8f9fa;
  border-radius: 6px;
  padding: 1rem;
  transition: all 0.3s ease;
}

.timeline-content:hover {
  transform: translateX(5px);
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.timeline-header {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
}

.identifier {
  font-weight: 600;
  color: #212529;
}

.timeline-concept {
  color: #6c757d;
  font-size: 0.9rem;
  margin-bottom: 0.25rem;
}

.timeline-amount {
  font-weight: 600;
  color: #212529;
  font-size: 1.1rem;
}

.timeline-status {
  margin-top: 0.5rem;
}

.timeline-status .badge {
  font-size: 0.8rem;
  padding: 0.4em 0.8em;
}

.badge {
  font-weight: 500;
  padding: 0.35em 0.65em;
  font-size: 0.75em;
}
</style> 